/**
 * Sanitizes a label for use in tracking names by removing special characters
 * and converting to a safe format for event tracking.
 *
 * @param label - The original label text
 * @returns A sanitized string safe for tracking names
 *
 * @example
 * sanitizeTrackingName("Coursera®") // returns "coursera"
 * sanitizeTrackingName("About Us™") // returns "about_us"
 * sanitizeTrackingName("Help & Support") // returns "help_support"
 * sanitizeTrackingName("Do Not Sell/Share") // returns "do_not_sell_share"
 */
export const sanitizeTrackingName = (label: string): string => {
  return label
    .replace(/[^\w\s]/g, '_') // Replace non-word characters with underscores
    .trim() // Trim leading/trailing whitespace
    .replace(/[\s_]+/g, '_') // Collapse multiple spaces/underscores into one underscore
    .replace(/^_+|_+$/g, '') // Remove leading/trailing underscores
    .toLowerCase(); // Convert to lowercase
};
